import { TextField as MuiTextField } from '@material-ui/core';
import { List } from '@monorepo/shared/componentsV2/List';
import { useSkipWidgetLink } from '@monorepo/shared/componentsV2/SkipWidgetLink';
import React from 'react';
import styled from 'styled-components';
import { DisplayQueryColumn } from '@monorepo/shared/componentsV2/QueryResultsTable/resultsMapper';
import { TruncatedColumnLabel } from './TruncatedColumnLabel';
import { StyledUnorderableListElement } from './UnorderableColumnListItem';
import { StyledListContainer, StyledListItemLabel } from './styles';

// ========================
// Styles.
// ========================
const StyledRenameListContainer = styled(StyledListContainer)`
  padding: 0.25rem 0;
`;

const StyledUnrenameableListItemLabel = styled(StyledListItemLabel)`
  margin-left: 2rem;
`;

const StyledMuiTextField = styled(MuiTextField)`
  width: calc(100% - 1.5rem);
  margin-bottom: 0.5rem;
  margin-left: 1.25rem;

  & .MuiInputBase-root {
    font-size: 0.875rem;

    & input {
      padding: 0.4rem 0.75rem;
      -webkit-text-stroke: transparent;
    }
  }
`;

// ========================
// Rendered components.
// ========================

export function RenameColumnList({
  visibleUnorderableColumns,
  visibleOrderableColumns,
  renameColumn,
  isSaving,
}: {
  visibleUnorderableColumns: DisplayQueryColumn[];
  visibleOrderableColumns: DisplayQueryColumn[];
  renameColumn: (column: DisplayQueryColumn, alias: string) => void;
  isSaving: boolean;
}) {
  const { SkipLink, SkipLinkTarget } = useSkipWidgetLink();
  return (
    <StyledRenameListContainer>
      <SkipLink linkText="Skip past columns" />
      <List>
        {visibleUnorderableColumns.map((column) => (
          <StyledUnorderableListElement key={column.columnName}>
            <StyledUnrenameableListItemLabel>
              <TruncatedColumnLabel column={column} showIcon />
            </StyledUnrenameableListItemLabel>
          </StyledUnorderableListElement>
        ))}
        {visibleOrderableColumns.map((column) => (
          <StyledUnorderableListElement key={column.columnName}>
            <StyledMuiTextField
              value={column.columnLabel}
              placeholder={column.originalColumnLabel}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                renameColumn(column, event.target.value);
              }}
              onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
                renameColumn(column, event.target.value.trim());
              }}
              disabled={isSaving}
              variant="outlined"
              size="small"
            />
          </StyledUnorderableListElement>
        ))}
      </List>
      <SkipLinkTarget />
    </StyledRenameListContainer>
  );
}
